import type { ActionType } from "typesafe-actions";
import { isActionOf } from "typesafe-actions";
import * as ac from "./action-creators";
import type { ContactExportPreview } from "../types/common";

export const extractContactsPreview = (
    action?: ActionType<typeof ac.fetchExportToCrmPreviewAsync>,
): ContactExportPreview[] => {
    if (action && isActionOf(ac.fetchExportToCrmPreviewAsync.success, action)) {
        return action.payload;
    }

    return [];
};

export const isFailedFetchingPreviewAction = (action?: ActionType<typeof ac.fetchExportToCrmPreviewAsync>) => {
    return action && isActionOf(ac.fetchExportToCrmPreviewAsync.failure, action);
};
